<template>
  <b-container class="info-container">
    <b-card
      class="card-description"
      text-variant="white"
      sub-title="Dados da Cobrança"
      :title="data.user.soft_descriptor"
      align="left"
    >
      <div
        v-for="(value, name) in dataInformation"
        :key="name"
        class="info-row"
      >
        <span class="info-label">{{ name }}:</span>
        <span class="info-value">{{ value }}</span>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import { BContainer, BCard, BCardText, BCol, BRow } from "bootstrap-vue";
import { doCardDescription } from "@/service/utilities/payment-link/payment-link";

export default {
  components: {
    BContainer,
    BCard,
    BCardText,
    BCol,
    BRow,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    valueWithInterest: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      dataInformation: null,
    };
  },
  watch: {
    valueWithInterest(value) {
      this.dataInformation = doCardDescription(this.data, value);
    },
  },
  created() {
    this.dataInformation = doCardDescription(this.data, this.valueWithInterest);
  },
};
</script>

<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
h1,h2,h3,h4,h5,h6,p, a {
  font-family: 'Poppins', sans-serif;
}

.card-description {
  background-color: #2e2c6c !important;
  border: none !important;
  border-radius: 10px !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  color: #fff !important;
  padding: 1rem 1rem !important;
  min-width: 110%;
  max-width: 110%;
  transform: scale(1.03);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  .card-subtitle {
    font-size: 1.4rem;
    font-weight: 700;
    color: white !important;
    margin-bottom: 0.3rem;
    line-height: 1.4;
  }

  .card-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #fff !important;
    text-transform: uppercase;
    margin-bottom: 1rem;
    line-height: 1.3;
  }

.info-row {
  position: relative;
  padding: 0.55rem 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-image: radial-gradient(#ffffffb7 1px, transparent 3px);
    background-size: 5px 1px; 
  }
}

  .label-col,
  .value-col {
    display: flex;
    align-items: flex-start;
  }

  .info-label {
    font-size: 1rem;
    color: #cfd2ff;
    font-weight: 500;
  }

  .info-value {
    font-size: 1.05rem;
    font-weight: 700;
    color: #fff;
    text-align: right;
    width: 100%;
    white-space: pre-line;
  }
}
</style>
